<template>
  <div
    v-if="!isRedirect"
    class="flex min-h-screen flex-col items-center justify-center"
  >
    <h1 class="mb-4 text-2xl font-bold">
      {{ error?.message || 'An error occurred' }}
    </h1>
    <p class="mb-8 text-gray-600">
      {{
        error?.statusCode === 404 ? 'Page not found' : 'Something went wrong'
      }}
    </p>
    <button
      class="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
      @click="handleError"
    >
      Go Back
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, type Ref } from 'vue'
import { useError, navigateTo, clearError } from '#imports'

interface ErrorWithData extends Error {
  statusCode?: number
  data?: {
    redirect?: string
  }
}

const error = useError() as Ref<ErrorWithData>
const isRedirect = computed(() => error.value?.statusCode === 302)

const handleError = () => {
  // Clear the error
  clearError()

  // Handle redirects
  if (error.value?.statusCode === 302 && error.value?.data?.redirect) {
    return navigateTo(error.value.data.redirect)
  }

  // Default to homepage for other errors
  return navigateTo('/')
}

// Handle redirects automatically
if (isRedirect.value && error.value?.data?.redirect) {
  handleError()
}
</script>
